module.exports = __webpack_public_path__ + "static/media/value-prop-icon-4.b7b82cfd.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/value-prop-icon-4.svg
// module id = 1299
// module chunks = 0